import { oc } from "ts-optchain";

import { mapGetters } from "vuex";

import { ObjectUtil } from "@/services";

import { CurrencyText } from "@/components";

import { IShoppingCartContext } from "../../Types";

export default {
  name: "CartTotals",
  components: {
    CurrencyText
  },
  props: {
    context: {
      type: Object,
      default: () => {
        return ObjectUtil.createInstance<IShoppingCartContext>();
      },
    },
    isStepThree: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(["getContentItem", "hasPermission"]),

    promotionsTotal() {
      return oc(this.context as IShoppingCartContext).cartData.PromotionsTotal();
    },

    partsTotal() {
      return oc(this.context as IShoppingCartContext).cartData.PartsTotal();
    },

    promotions() {
      let promotions = "";
      this.context.promoCodes.forEach(promo => {
        promotions += `${promo}, `
      })
      return promotions.substring(0, promotions.length -2);
    }
  },
};
